import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Alert } from 'reactstrap';
import { getAlertNotification, setAlertNotification } from '../../store/common'

const AlertNotification = ({ notification, closeAlertNotification }) => {
    return(
        <div>
            {notification ?
            <Alert color={notification.type} toggle={() => closeAlertNotification()}>
                {notification.message}
            </Alert>
            :null }
        </div>
        )
    }
    AlertNotification.propTypes = {
        notification: PropTypes.object,
        closeAlertNotification: PropTypes.func.isRequired
    }

    const mapStateToProps = state => ({
        notification: getAlertNotification(state.common.notifications)
      })
      
    const mapDispatchToProps = (dispatch, ownProps) => ({
        closeAlertNotification:() => dispatch(setAlertNotification()),
      });
      
    export default connect(
        mapStateToProps,
        mapDispatchToProps
      )(AlertNotification)
      


// WEBPACK FOOTER //
// ./src/molecules/containers/AlertNotification.js